<script lang="ts">
  // Stores
  import { getCarouselContext } from "$lib/utils/section-carousel"

  export let id: string | null = null;

  const { carousels, updateCurrentIndex } = getCarouselContext()
  const { currentIndex, pagesCount, slides, duration } = $carousels[id]?$carousels[id]:{};

  let currentProgress = duration === 0 ? 100 : 0
  let timeout: any;

  const changeSlide = (i: number) => {
    updateCurrentIndex(id, i)
  }

  const startTimer = () => {
    clearTimeout(timeout)

    const step = () => {
      timeout = setTimeout(() => {
        currentProgress += 1

        if (currentProgress > 100) {
          currentProgress = 0

          if ($currentIndex + 1 === $pagesCount) {
            updateCurrentIndex(id, 0)
          } else {
            updateCurrentIndex(id, $currentIndex + 1)
          }
        } else {
          step()
        }
      }, duration / 100)
    }

    step()
  }

  carousels.subscribe(carousels => {
    carousels[id]?.currentIndex?.subscribe(_ => {
      if (typeof window !== "undefined" && duration > 0) {
        currentProgress = 0
        startTimer()
      }
    })
  })
</script>

{#if $carousels[id] && $slides && $slides.length > 0 && $pagesCount > 1}
  <div class="section-carousel-indicators">
    {#each Array($pagesCount) as _, i}
      <button
        type="button"
        class="carousel-indicator"
        class:active="{i === $currentIndex}"
        aria-current="{i === $currentIndex ? 'true' : undefined}"
        aria-label="Slide {i + 1}"
        on:click={() => changeSlide(i)}
      >
        <span class="indicator">
          {#if i === $currentIndex}
            <span class="indicator-progress" style="width:{currentProgress}%" aria-valuenow="{currentProgress}"></span>
          {/if}
        </span>
      </button>
    {/each}
  </div>
{/if}

<style type="text/scss" lang="scss" scoped>
  .section-carousel-indicators {
    @apply inline-flex items-end justify-end;
    @apply -m-0.5;
  }

  .carousel-indicator {
    @apply py-5 px-0.5;
    @apply text-gray-300;
    @apply focus:outline-none;

    &.active {
      @apply text-gray-900;
    }

    &:hover {
      .indicator {
        @apply scale-y-300;
      }
    }
  }

  .indicator {
    @apply block relative;
    @apply w-7 h-0.5;
    @apply bg-gray-300;
    @apply transform scale-y-100;
    @apply transition-transform duration-200;
  }

  .indicator-progress {
    @apply block;
    @apply absolute left-0 inset-y-0;
    @apply bg-current;
  }
</style>
